<template>
  <transition name="fade" mode="out-in">
    <div id="pay">
      <div class="paying-gif"></div>
      <p class="result-tips" v-html="languages.browserPayingTips"></p>
      <div class="follow-operation">
        <button
          class="follow-operation-btn redBg contact-us"
          @click="showFeebackPage"
          type="button"
        >
          <i class="pay-res-btn money"></i>
          <span class="follow-operation-btn-text">
            {{ languages.browserPayErrBtnText }}
          </span>
        </button>
        <button
          class="follow-operation-btn purpleBg"
          @click="backGame"
          type="button"
        >
          <i class="pay-res-btn pay-success"></i>
          <span class="follow-operation-btn-text">
            {{ languages.browserPaySucBtnText }}
          </span>
        </button>
      </div>
    </div>
  </transition>
</template>
<script>
import bridge from '../../utiles/bridge';
import { FEEKBACK_URL } from '../../utiles';
const OPEN_BROSWER_METHOD = 'openBrowser';
export default {
  name: 'result',
  computed: {
    languages() {
      return this.$store.state.store.languages;
    },
  },
  methods: {
    showFeebackPage() {
      bridge.callSdkMethod(OPEN_BROSWER_METHOD, {
        url: FEEKBACK_URL,
        loginDir: 1,
        appendParams: 1,
      });
    },
    backGame() {
      bridge.callSdkMethod('closeWebview');
    },
  },
};
</script>
